import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageModule } from 'primeng/image';
import { environment } from '../../../environments/environment';
import { ChipModule } from 'primeng/chip';
import { AccordionModule } from 'primeng/accordion'
import { DataService } from '../../service/data.service';
import { MapService } from '../../service/map.service';
import { CSSStyle } from '../../http/cssStyle';

@Component({
    selector: 'app-response',
    standalone: true,
    imports: [CommonModule, ImageModule, ChipModule, AccordionModule],
    templateUrl: './response.component.html',
    styleUrl: './response.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResponseComponent extends HTMLElement implements OnInit, AfterViewInit {

    @ViewChild('map') mapElement: any;
    map?: google.maps.Map;
    mapURL = ""

    @Input()
    expandIndex?: number;
    allResponseType?: string[];
    allResponseInfoArray?: { [key: string]: string }[][]
    targetDiv: ViewContainerRef | undefined
    chattingWrapper: ElementRef | undefined
    expandedDiv: ViewContainerRef | undefined
    environment = environment
    results: any = [];
    mapIndex!: number;
    properties?: CSSStyle;
    copied = false

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.dataService.isCurrentlyExpanding = false
        this.allResponseInfoArray?.forEach((json: any) => {
            if (json[0].expand) {
                this.dataService.expandIndex += 1
            }
        })
        this.mapService.checkMap(this.mapIndex, this.map!, this.mapElement, this.allResponseType!, this.allResponseInfoArray!)
        this.dataService.scrollToBottom(this.chattingWrapper!)
    }

    constructor(private dataService: DataService, private changeView: ChangeDetectorRef, private mapService: MapService) {
        super()
    }

    copy(message: string) {
        if (!this.copied) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(message, 'text/html');
            const plainText = doc.body.textContent || doc.body.innerText
            navigator.clipboard.writeText(plainText).then(() => {
                this.copied = true
                setTimeout(() => {
                    this.copied = false
                }, 3000)
            }).catch((err) => {
                console.error('Error copying text: ', err);
            });
        }
    }

    onButtonClick(askType: string, message: string = '', buttonResponse: any = '') {
        if (askType == 'set-address' && !this.mapService.canSetAddress) {
            return //Cannot call multiple set addresses
        }
        if (askType == 'confirm-address') {
            if (this.dataService.confirmAddress) {
                message = "My address is " + this.dataService.confirmAddress
                askType = 'text'
            } else {
                message = "Please enter an address"
                this.updateAskType('error')
                this.dataService.postMessage(message, this.targetDiv!, this.changeView, this.chattingWrapper!, this.properties!, this.expandedDiv!,)
                return
            }
        } else if (askType == "show_map" && buttonResponse["description"] != null) {
            this.dataService.createResponseNoPost(buttonResponse["description"], this.targetDiv!, this.changeView, this.chattingWrapper!, this.properties!, this.expandedDiv!,)
            return
        } else if (askType == "sms") {
            message = "Send a text message, the message to send is " + this.allResponseInfoArray![0][0]["message"]
            askType = 'text'
            this.dataService.postMessage(message, this.targetDiv!, this.changeView, this.chattingWrapper!, this.properties!, this.expandedDiv!,)
            return
        }
        this.updateAskType(askType)
        if (message) {
            this.dataService.userMessage(this.targetDiv!, message, this.changeView, this.chattingWrapper!,)
        }
        this.dataService.postMessage(message, this.targetDiv!, this.changeView, this.chattingWrapper!, this.properties!, this.expandedDiv!,)
    }

    updateAskType(askType: string) {
        this.dataService.updateAskType(askType)
    }
}
